// API Configuration
export const API_CONFIG = {
  BASE_URL: process.env.NEXT_PUBLIC_API_URL || 'http://localhost:8000',
  ENDPOINTS: {
    AUTH: {
      DEBUG_LOGIN: '/auth/debug-login',
      TELEGRAM_WIDGET_LOGIN: '/auth/telegram-widget-login',
      LOGOUT: '/auth/logout',
    },
    CHATS: {
      LIST: '/chats',
    },
    DASHBOARD: {
      STATS: '/dashboard',
    },
  },
} as const;

// Добавляем отладку для проверки URL
console.log('API Base URL:', API_CONFIG.BASE_URL);

// API Response Types
export interface AuthResponse {
  id: number;
  user_id: number;
  first_name: string;
  second_name: string;
  user_name: string;
  role: number;
}

export interface AuthRequest {
  login: string;
  password: string;
}

// Telegram Widget Types
export interface TelegramUserData {
  id: number;
  first_name: string;
  last_name?: string;
  username?: string;
  photo_url?: string;
  auth_date: number;
  hash: string;
}

export interface TelegramAuthRequest {
  data_check_string: string;
}

// Chat Types
export interface ChatAdmin {
  id: number;
  user_id: number;
  first_name: string;
  second_name: string | null;
  user_name: string;
  role: number;
}

export interface Chat {
  id: number;
  title: string;
  chat_name: string | null;
  need_nda: boolean;
  created_at: string;
  meeting_url: string;
  chat_status: string;
  active: boolean;
  brief_date: string | null;
  admin_id: number;
  admin: ChatAdmin;
}

export interface ChatsListParams {
  limit?: number;
  offset?: number;
  show_inactive?: boolean;
}

// Chat Update Types
export interface ChatUpdate {
  title?: string | null;
  chat_name?: string | null;
  need_nda?: boolean | null;
  meeting_url?: string | null;
  chat_status?: string | null;
  brief_date?: string | null;
  active?: boolean | null;
}

// Chat Response (same as Chat but for API responses)
export type ChatResponse = Chat;

// Dashboard Types
export interface PaymentStats {
  amount: number;
  count: number;
}

export interface TopUser {
  user_username: string;
  user_rating: number;
  user_first_name: string;
}

export interface DashboardStats {
  total_chats: number;
  total_users: number;
  users_with_nda: number;
  payments_this_month: PaymentStats;
  payments_last_year: PaymentStats;
  payments_last_30_days: PaymentStats;
  payments_last_7_days: PaymentStats;
  chats_with_design_tag: number;
  chats_with_creative_tag: number;
  chats_with_strategy_tag: number;
  chats_with_anticrisis_tag: number;
  chats_with_sprint_tag: number;
  users_with_design_tag: number;
  users_with_creative_tag: number;
  users_with_strategy_tag: number;
  users_with_anticrisis_tag: number;
  users_with_sprint_tag: number;
  top_users: TopUser[];
}
